module.exports = __webpack_public_path__ + "img/layer.e7c5b641.png";